export default {"pages":"_7rzZj","noOddsFormatSelection":"oC7X3","page":"fIDxc H9fHT UzvkT","offerCount":"_222Ks","selected":"lbIEE"};